exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".home-page {\n  max-width: 1040px;\n  padding: 5px;\n  margin: auto;\n}\n", "", {"version":3,"sources":["/home/guille/chinespain/tripmaker-redux/src/app/components/Home.less","/home/guille/chinespain/tripmaker-redux/src/app/components/Home.less"],"names":[],"mappings":"AACA;EACE,kBAAA;EACA,aAAA;EACA,aAAA;CCAD","file":"Home.less","sourcesContent":["\n.home-page {\n  max-width: 1040px;\n  padding: 5px;\n  margin: auto;\n}\n",".home-page {\n  max-width: 1040px;\n  padding: 5px;\n  margin: auto;\n}\n"],"sourceRoot":""}]);

// exports
